import {register} from '@shopify/theme-sections';

export default register('contact-form', {
  onLoad() {
    /**
     * Manually handle form submissions so that we can add GTM tracking,
     * and pass UTM parameters through to Salesforce.
     */
    (() => {
      const $form = this.container.querySelector('form');
      if ($form === null) return;

      // ===================================================
      // Add UTM parameters to form to track ad conversions
      // ===================================================

      const addUtmFields = () => {
        /**
         * Check if we have stored UTM params. If not, return.
         */
        const hasStoredParams = sessionStorage.getItem('utmParams');
        if (hasStoredParams === null) return;
        const storedUtmParams = JSON.parse(hasStoredParams);

        const formUtmParams = [
          {title: 'utm_source', salesforce_id: 'GA_Source', name: '00N0o00000NVClT'},
          {title: 'utm_medium', salesforce_id: 'GA_Medium', name: '00N0o00000NVClS'},
          {title: 'utm_campaign', salesforce_id: 'GA_Campaign', name: '00N0o00000NVClQ'},
          {title: 'utm_content', salesforce_id: 'GA_Content', name: '00N0o00000NVClR'},
          {title: 'utm_term', salesforce_id: 'GA_Term', name: '00N0o00000NVClU'},
        ];

        /**
         * Filter the formUtmParams array with the UTM params that have been stored,
         * as not all UTM params will be set at all times.
         *
         * Null check here is likely not needed in practice but kept for completeness.
         */
        const validParams = formUtmParams.filter(param => storedUtmParams.hasOwnProperty(param.title));
        if (validParams.length < 1) return;

        /**
         * For each UTM key/value pair, create a hidden input in the <form>.
         */
        validParams.forEach(formFieldData => {
          let inputField = document.createElement('input');
          inputField.type = 'hidden';
          inputField.id = formFieldData.salesforce_id;
          inputField.name = formFieldData.name;
          inputField.value = storedUtmParams[formFieldData.title];
          $form.appendChild(inputField);
        });
      };

      addUtmFields();

      // ===================================================
      // Track form submissions with a custom GTM event
      // ===================================================

      // Retrieve the form name set in theme customiser
      const $formWrapper = this.container.querySelector('[data-form-name]');
      let formName = 'untitled';
      if ($formWrapper) {
        const formNameValue = $formWrapper.dataset.formName.trim();
        formName = formNameValue === '' ? formName : formNameValue;
      }

      // Replace <input> submit with <button> submit so that we can use
      // the form.requestSubmit() method to re-submit the form.
      const inputSubmit = $form.querySelector('input[name=submit]');
      if (inputSubmit) {
        const buttonSubmit = document.createElement('button');
        buttonSubmit.setAttribute('type', 'submit');
        buttonSubmit.setAttribute('name', 'submit');
        buttonSubmit.textContent = 'Submit';
        $form.insertBefore(buttonSubmit, inputSubmit);
        inputSubmit.remove();
      }

      // Check if user landed on the form via an on-site CTA
      const viaFeature = new URLSearchParams(window.location.search).get('via-feature');

      // Prevent the initial HTML form submission so that we have time
      // to fire the GTM tag. After a small timeout, resubmit the form.
      // The 'once' eventListener flag is set so that we don't end up in
      // a form submission loop.
      const handleFormSubmit = () => {
        $form.addEventListener(
          'submit',
          evt => {
            evt.preventDefault();

            const eventObj = {
              event: 'contactFormSubmission',
              details: {
                formName,
              },
            };

            if (viaFeature && viaFeature !== '') {
              eventObj.details.viaFeature = viaFeature;
            }

            // Create GTM event
            window.dataLayer = window.dataLayer || {};
            window.dataLayer.push(eventObj);

            // Set a small delay to give the GTM event time to be captured,
            // then use requestSubmit() to re-submit the HTML form.
            setTimeout(() => {
              $form.requestSubmit();
            }, 500);
          },
          {once: true}
        );
      };

      // Handle recaptcha-protected and non-protected forms differently
      const $recaptcha = $form.querySelector('.g-recaptcha');
      if ($recaptcha) {
        // Register a callback for recaptcha success
        $recaptcha.setAttribute('data-callback', 'handleRecaptchaSuccess');

        // If a verification is successful, register form submit handler
        window.handleRecaptchaSuccess = () => handleFormSubmit();
      } else {
        // If there's no recaptcha, register the form submit handler
        handleFormSubmit();
      }
    })();
  },
});
